import { render, staticRenderFns } from "./Forum.vue?vue&type=template&id=92592bd4&scoped=true&"
import script from "./Forum.vue?vue&type=script&lang=js&"
export * from "./Forum.vue?vue&type=script&lang=js&"
import style0 from "./Forum.vue?vue&type=style&index=0&id=92592bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92592bd4",
  null
  
)

component.options.__file = "Forum.vue"
export default component.exports